<template lang="pug">
.row.mt-4(v-if="loaded && transactions.list.length != 0")
  .col-12
    h3 Статистика склада
  .col.white_block(v-if="transactions.list.length == 0") 
    .not_found На данный момент отсутствует статистика по позициям.
  .col.white_block(v-if="transactions.list.length != 0")
    .row(:class="{ updating: transactions.updating }")
      .col
        line-chart.wide_chart(:chartData="transactions.main_chart")
</template>

<script>
import LineChart from "../line_chart";
export default {
  components: {
    LineChart,
  },
  props: ["transactions", "loaded"],
};
</script>